import { computed, ExtractPropTypes } from 'vue'
import { useRoute } from 'vue-router'
import { ERROR_PAGE_PROPS } from './types'

type ErrorPageProps = ExtractPropTypes<typeof ERROR_PAGE_PROPS>

/**
 *
 * @param props
 */
export function setup(props: ErrorPageProps) {
  const route = useRoute()

  const errorMessage = computed(() => {
    const queryMsg = route.query.message
    const queryMessage = Array.isArray(queryMsg) ? queryMsg[0] : queryMsg
    return props.message ?? queryMessage ?? 'An unexpected error has occurred'
  })

  return { errorMessage }
}
